import { Button, Image, Theme, Body2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingCurrentDecorationProps {
  title: React.ReactElement;
  subtitle: string;
  thumbnails: {
    sourceUrl?: string | null;
    url: string;
  }[];
  onClick(): void;
  popup: React.ReactElement;
}

export const NewbuildingCurrentDecoration = ({
  title,
  subtitle,
  thumbnails,
  onClick,
  popup,
}: INewbuildingCurrentDecorationProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>{title}</div>
      <div className={styles['subtitle']}>
        <Body2>{subtitle}</Body2>
      </div>

      <div className={styles['gallery']} onClick={onClick}>
        <div className={styles['grid']}>
          {thumbnails.map(item => (
            <div key={item.url} className={styles['item']}>
              <Image objectFit="cover" src={item.url} />
            </div>
          ))}
        </div>
        <div className={styles['preview-button']}>
          <Theme theme="onOverlay">
            <Button size="XS" theme="main_primary" onClick={onClick}>
              Как это может выглядеть
            </Button>
          </Theme>
        </div>
        <div className={styles['details-button']}>
          <Theme theme="onOverlay">
            <Button size="M" theme="main_secondary" onClick={onClick}>
              Подробнее об отделке
            </Button>
          </Theme>
        </div>
      </div>
      {popup}
    </div>
  );
};
